import validator from "validator";

 /***************************************************
   functions to validate each form step
*****************************************************/
const ignoreWhiteSpace = { ignore_whitespace : true } ;

export const validateStep1 = ( formData ) => {

    let validated = false
    let errors = {}     
    const start_date = formData.start_date === null ? '' : formData.start_date.toString()
    const end_date = formData.end_date === null ? '' : formData.end_date.toString()

    if(validator.isEmpty(formData.project_name , ignoreWhiteSpace)){
        errors.project_name = "project name can't be empty" ;          
    } 
     else if( validator.isEmpty(formData.project_description, ignoreWhiteSpace) ){
        errors.project_description = "project description can't be empty" ;        
     }

     else if( validator.isEmpty(start_date, ignoreWhiteSpace)){
                  errors.start_date_and_time = "start date and time can't be empty" ;        
          }
    
    else if( validator.isEmpty(end_date, ignoreWhiteSpace)){
              errors.end_date_and_time = "end date and time can't be empty" ;        
      }    
     else validated = true;

     return { validated , errors };
} 

export const validateStep2 = ( formData ) => {

    let validated = true;
    let errors = {}      
    let emails = formData.participants.map( participant => participant.email )
    let isDuplicateEmail = emails.length !== new Set( emails ).size

    formData.participants.forEach( (participant,id) => {        
         if(  validator.isEmpty(participant.name, ignoreWhiteSpace)
               ||  validator.isEmpty(participant.email, ignoreWhiteSpace) 
              ||  validator.isEmpty(participant.dev_coach_name, ignoreWhiteSpace) 
              ||  validator.isEmpty(participant.dev_coach_email, ignoreWhiteSpace)  
              ||  validator.isEmpty(participant.password.toString(), ignoreWhiteSpace)
            )
         {              
             errors.participant = `each field in every row is required found empty field  at row  ${id + 1} `
             validated = false ; 
         }    
         else if( !validator.isEmail(participant.email) ) {
            errors.participant = `invalid email address at row ${ id + 1 }`
            validated = false ; 
         }
         
         else if( participant.password.length < 8  ) {
            errors.participant = `Password should not be less than 8 characters at row ${ id + 1 }`
            validated = false ; 
         }  

         else if(isDuplicateEmail){
            errors.participant = `Each participant's email address must be unique. Please check your email inputs`
            validated = false ; 
         }
         else if( !validator.isEmail(participant.dev_coach_email) ) {
            errors.participant = `invalid development coach email address at row ${ id + 1 }`
            validated = false ; 
         }                                                             
    });    

     return { validated , errors };
} 

export const validateStep3 = ( formData ) => {

   let validated = false
   let errors = {}         

   if(validator.isEmpty(formData.sender_email , ignoreWhiteSpace)){
       errors.sender_email = "sender email address can't be empty" ;          
   } 
    else if( !validator.isEmail(formData.sender_email) ){
       errors.sender_email = "Invalid email address" ;        
    }

    else if( validator.isEmpty(formData.email_reply_to, ignoreWhiteSpace)){
                 errors.reply_to = "reply to email can't be empty" ;        
         }
   
   else if( validator.isEmpty(formData.email_subject, ignoreWhiteSpace)){
             errors.email_subject = "email subject can't be empty" ;        
     }    
    else validated = true;

    return { validated , errors };
} 